import { ConeCrusherCSTypes } from './ConeCrusherCSTypes';
import type { AvailableBushingsMapInterface } from '../CrusherConeCH/CrusherConeCHTypes';
import type { CrusherDataMapInterface } from 'unitData/Crushers/BaseCrusherTypes';
import { CSCrusherGetMaxCSS } from 'unitData/Crushers/ConeCrusherCS/ConeCrusherCSInfo';
import type { UnitInfoCrusherInterface } from 'store/units/types';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { ConeCrusherCSUnitInfoDataMapInterface } from './unitInfoData';
import { getDefaultHighBinData } from '../CrusherConeCH/CrusherConeCHData';

export const ConeCrusherCSData: CrusherDataMapInterface = {
  [ConeCrusherCSTypes.CS420]: {
    concaves: {
      EC: {
        mantles: ['A', 'B'],
        throws: [16, 20, 25],
      },
      C: {
        mantles: ['A', 'B'],
        throws: [16, 20, 25],
      },
    },
  },
  [ConeCrusherCSTypes.CS430]: {
    concaves: {
      EC: {
        mantles: ['A', 'B'],
        throws: [16, 20, 25, 30],
      },
      C: {
        mantles: ['A', 'B'],
        throws: [16, 20, 25, 30],
      },
      MC: {
        mantles: ['A', 'B'],
        throws: [16, 20, 25, 30],
      },
    },
  },
  [ConeCrusherCSTypes.CS440]: {
    concaves: {
      EC: {
        mantles: ['A', 'B'],
        throws: [20, 25, 30, 36],
      },
      C: {
        mantles: ['A', 'B'],
        throws: [20, 25, 30, 36],
      },
      MC: {
        mantles: ['A', 'B'],
        throws: [20, 25, 30, 36],
      },
    },
  },
  [ConeCrusherCSTypes.CS660]: {
    concaves: {
      EC: {
        mantles: ['A', 'B'],
        throws: [20, 25, 30, 35, 40],
      },
      C: {
        mantles: ['A', 'B'],
        throws: [20, 25, 30, 35, 40],
      },
      MC: {
        mantles: ['A', 'B'],
        throws: [20, 25, 30, 35, 40],
      },
    },
  },
  [ConeCrusherCSTypes.CS840i]: {
    concaves: {
      EC: {
        mantles: ['A', 'B'],
        throws: [24, 28, 32, 36, 40, 44, 48],
      },
      C: {
        mantles: ['A', 'B'],
        throws: [24, 28, 32, 36, 40, 44, 48],
      },
    },
  },
};

export const AvailableBushings: AvailableBushingsMapInterface = {
  [ConeCrusherCSTypes.CS420]: {
    concaves: {
      EC: {
        16: ['16 + 20 + 25'],
        20: ['16 + 20 + 25'],
        25: ['16 + 20 + 25'],
      },
      C: {
        16: ['16 + 20 + 25'],
        20: ['16 + 20 + 25'],
        25: ['16 + 20 + 25'],
      },
    },
  },
  [ConeCrusherCSTypes.CS430]: {
    concaves: {
      EC: {
        16: ['16 + 20 + 25 + 30'],
        20: ['16 + 20 + 25 + 30'],
        25: ['16 + 20 + 25 + 30'],
        30: ['16 + 20 + 25 + 30'],
      },
      C: {
        16: ['16 + 20 + 25 + 30'],
        20: ['16 + 20 + 25 + 30'],
        25: ['16 + 20 + 25 + 30'],
        30: ['16 + 20 + 25 + 30'],
      },
      MC: {
        16: ['16 + 20 + 25 + 30'],
        20: ['16 + 20 + 25 + 30'],
        25: ['16 + 20 + 25 + 30'],
        30: ['16 + 20 + 25 + 30'],
      },
    },
  },

  [ConeCrusherCSTypes.CS440]: {
    concaves: {
      EC: {
        20: ['20 + 25 + 30 + 36'],
        25: ['20 + 25 + 30 + 36'],
        30: ['20 + 25 + 30 + 36'],
        36: ['20 + 25 + 30 + 36'],
      },
      C: {
        20: ['20 + 25 + 30 + 36'],
        25: ['20 + 25 + 30 + 36'],
        30: ['20 + 25 + 30 + 36'],
        36: ['20 + 25 + 30 + 36'],
      },
      MC: {
        20: ['20 + 25 + 30 + 36'],
        25: ['20 + 25 + 30 + 36'],
        30: ['20 + 25 + 30 + 36'],
        36: ['20 + 25 + 30 + 36'],
      },
    },
  },

  [ConeCrusherCSTypes.CS660]: {
    concaves: {
      EC: {
        20: ['20 + 25 + 30 + 35 + 40'],
        25: ['20 + 25 + 30 + 35 + 40'],
        30: ['20 + 25 + 30 + 35 + 40'],
        35: ['20 + 25 + 30 + 35 + 40'],
        40: ['20 + 25 + 30 + 35 + 40'],
      },
      C: {
        20: ['20 + 25 + 30 + 35 + 40'],
        25: ['20 + 25 + 30 + 35 + 40'],
        30: ['20 + 25 + 30 + 35 + 40'],
        35: ['20 + 25 + 30 + 35 + 40'],
        40: ['20 + 25 + 30 + 35 + 40'],
      },
      MC: {
        20: ['20 + 25 + 30 + 35 + 40'],
        25: ['20 + 25 + 30 + 35 + 40'],
        30: ['20 + 25 + 30 + 35 + 40'],
        35: ['20 + 25 + 30 + 35 + 40'],
        40: ['20 + 25 + 30 + 35 + 40'],
      },
    },
  },

  [ConeCrusherCSTypes.CS840i]: {
    concaves: {
      EC: {
        24: ['24 + 28 + 32'],
        28: ['24 + 28 + 32'],
        32: ['24 + 28 + 32', '32 + 36 + 40'],
        36: ['32 + 36 + 40'],
        40: ['32 + 36 + 40', '40 + 44 + 48'],
        44: ['40 + 44 + 48'],
        48: ['40 + 44 + 48'],
      },
      C: {
        24: ['24 + 28 + 32'],
        28: ['24 + 28 + 32'],
        32: ['24 + 28 + 32', '32 + 36 + 40'],
        36: ['32 + 36 + 40'],
        40: ['32 + 36 + 40', '40 + 44 + 48'],
        44: ['40 + 44 + 48'],
        48: ['40 + 44 + 48'],
      },
    },
  },
};

export const getBushings = (
  modelName: string,
  concaveName: string,
  selectedThrow: number,
) => {
  const concaves = AvailableBushings[modelName].concaves;

  if (concaves[concaveName]?.[selectedThrow]) {
    return concaves[concaveName][selectedThrow];
  } else {
    return [''];
  }
};

export interface ConeCrusherCSDataMapInterface {
  [modelName: string]: ConeCrusherCSDataInterface;
}

export interface ConeCrusherCSDataInterface {
  concaves: {
    [concaveName: string]: ConcaveInterface;
  };
  throws: number[];
}

export interface ConcaveInterface {
  mantles: string[];
}

export class CrusherConeCSconfiguration extends BaseUnitConfig {
  static getDefaultData(params?: UnitConfigParams): UnitInfoCrusherInterface {
    const unitInfoData =
      (params?.data as ConeCrusherCSUnitInfoDataMapInterface | undefined) ?? {};

    const modelName = Object.keys(ConeCrusherCSData)[0];
    const concaveName = Object.keys(ConeCrusherCSData[modelName]?.concaves)[1];
    const mantleName =
      ConeCrusherCSData[modelName]?.concaves[concaveName]?.mantles[1];
    const unitThrow =
      ConeCrusherCSData[modelName].concaves[concaveName].throws[0];
    const maxCSS = CSCrusherGetMaxCSS(
      modelName,
      concaveName,
      mantleName,
      unitThrow,
      unitInfoData,
    );
    const bushings = getBushings(modelName, concaveName, unitThrow);

    return {
      modelName: modelName,
      concave: concaveName,
      mantle: mantleName,
      unitThrow: unitThrow,
      bushing: bushings.length ? bushings[0] : '',
      css: 25,
      ...BaseUnitConfig.getBaseDefaults(),
      maxCSS: maxCSS || 0,
      showCustomModel: false,
      highBin: getDefaultHighBinData(),
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayRiskLevel: false,
        displayThrow: true,
        displayCss: true,
        displayMinLiveBin: true,
        displayConcave: true,
        displayMantle: true,
        displayBushing: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const crusherConeCSConfig = new CrusherConeCSconfiguration();
